<template>
    <div>

        <fieldset>
            <legend>行程设定</legend>
            <div class="param-row">
                <label>行程长(x):</label>
                <NumberInput v-model="xTravel" style="width:80px" @paste-pair="([x, y]) => { xTravel = x; yTravel = y }" />
                <span class="hint">行程宽(y):</span>
                <NumberInput v-model="yTravel" style="width:80px" @paste-pair="([x, y]) => { xTravel = x; yTravel = y }" />
            </div>
        </fieldset>

        <fieldset>
            <legend>刀具与加工参数</legend>
            <div class="param-row">
                <label>主轴转速:</label>
                <NumberInput v-model="spindleRPM" style="width:100px" />
            </div>
            <div class="param-row">
                <label>进给:</label>
                <NumberInput v-model="feed" style="width:100px" />
            </div>
            <div class="param-row">
                <label>刀具直径:</label>
                <NumberInput v-model="toolDiameter" style="width:100px" />
            </div>
        </fieldset>

        <fieldset>
            <legend>顶面加工参数</legend>
            <div class="param-row">
                <label>深度:</label>
                <NumberInput v-model="totalDepth" style="width:100px" />
            </div>
            <div class="param-row">
                <label>抬刀高度:</label>
                <NumberInput v-model="retractHeight" style="width:80px" />
                <span class="hint">每层抬刀量</span>
            </div>
            <div class="param-row">
                <label>安全高度:</label>
                <NumberInput v-model="safeZ" style="width:100px" />
            </div>
            <div class="param-row">
                <label>面铣吃刀量(%):</label>
                <NumberInput v-model="millCutting" style="width:80px" />
                <span class="hint">={{ millCuttingActual.toFixed(1) }}mm</span>
            </div>
            <div class="param-row">
                <label>每层下刀深度:</label>
                <NumberInput v-model="levelDepth" style="width:100px" />
            </div>
            <div class="param-row">
                <label>走刀方式:</label>
                <label style="width:auto"><input v-model="pattern" type="radio" value="zigzag"> 往复</label>
                <label style="width:auto"><input v-model="pattern" type="radio" value="spiral"> 回旋</label>
            </div>
            <div class="param-row" v-if="pattern === 'zigzag'">
                <label>往复方向:</label>
                <label style="width:auto"><input v-model="zigzagDir" type="radio" value="horizontal"> 横向</label>
                <label style="width:auto"><input v-model="zigzagDir" type="radio" value="vertical"> 纵向</label>
            </div>
            <div class="param-row" v-if="pattern === 'zigzag'">
                <label>开始位置:</label>
                <label style="width:auto"><input v-model="startSide" type="radio" value="left"> 左侧</label>
                <label style="width:auto"><input v-model="startSide" type="radio" value="right"> 右侧</label>
            </div>
        </fieldset>

        <fieldset>
            <legend>生成</legend>
            <div class="param-row">
                <label style="width:auto"><input v-model="bZReturn" type="checkbox"> Z轴回原点</label>
            </div>
            <div class="param-row">
                <label style="width:auto"><input v-model="bZeroPass" type="checkbox"> Z起始位置预走一刀</label>
            </div>
            <button @click="generateNC">后处理NC文件</button>
        </fieldset>

        <svg viewBox="0 0 400 260" style="width:100%; max-width:440px; margin-top:12px; border:1px solid #ddd; border-radius:4px; background:#fafafa;">
            <defs>
                <marker id="arr" markerWidth="6" markerHeight="4" refX="6" refY="2" orient="auto">
                    <path d="M0,0 L6,2 L0,4 Z" fill="#e0550a"/>
                </marker>
                <marker id="dimArr" markerWidth="6" markerHeight="4" refX="6" refY="2" orient="auto">
                    <path d="M0,0 L6,2 L0,4 Z" fill="#2b6cb0"/>
                </marker>
            </defs>

            <!-- 行程长 (x) —— 回旋：xTravel不含起点overhang；往复：xTravel=起点到左边 -->
            <line x1="87" y1="210" x2="87" y2="218" stroke="#2b6cb0" stroke-width="1.2"/>
            <line :x1="pattern === 'spiral' ? '237' : '255'" y1="210" :x2="pattern === 'spiral' ? '237' : '255'" y2="218" stroke="#2b6cb0" stroke-width="1.2"/>
            <line x1="87" y1="214" :x2="pattern === 'spiral' ? '237' : '255'" y2="214" stroke="#2b6cb0" stroke-width="1.2"/>
            <polygon points="93,210 87,214 93,218" fill="#2b6cb0"/>
            <polygon :points="pattern === 'spiral' ? '231,210 237,214 231,218' : '249,210 255,214 249,218'" fill="#2b6cb0"/>
            <text :x="pattern === 'spiral' ? '162' : '171'" y="228" text-anchor="middle" fill="#2b6cb0" font-size="11">x</text>

            <!-- 行程宽 (y) -->
            <line x1="43" y1="80" x2="51" y2="80" stroke="#2b6cb0" stroke-width="1.2"/>
            <line x1="43" y1="170" x2="51" y2="170" stroke="#2b6cb0" stroke-width="1.2"/>
            <line x1="47" y1="80" x2="47" y2="170" stroke="#2b6cb0" stroke-width="1.2"/>
            <polygon points="43,86 47,80 51,86" fill="#2b6cb0"/>
            <polygon points="43,164 47,170 51,164" fill="#2b6cb0"/>
            <text x="39" y="128" text-anchor="end" fill="#2b6cb0" font-size="11" transform="rotate(-90,39,128)">y</text>

            <!-- 刀具在起点 (r=15 比例匹配) -->
            <circle :cx="svgToolCX" :cy="svgToolCY" r="15" fill="none" stroke="#e0550a" stroke-width="2.5"/>
            <circle :cx="svgToolCX" :cy="svgToolCY" r="2" fill="#e0550a"/>
            <line :x1="svgToolCX - 17" :y1="svgToolCY" :x2="svgToolCX + 17" :y2="svgToolCY" stroke="#e0550a" stroke-width="0.7"/>
            <line :x1="svgToolCX" :y1="svgToolCY - 17" :x2="svgToolCX" :y2="svgToolCY + 17" stroke="#e0550a" stroke-width="0.7"/>

            <!-- 起点 (当前刀具位置) -->
            <circle :cx="svgToolCX" :cy="svgToolCY" r="4.5" fill="#c00"/>
            <line :x1="svgToolCX + 4" :y1="svgToolCY" :x2="svgToolCX + 20" :y2="svgToolCY - 6" stroke="#c00" stroke-width="1"/>
            <text :x="svgToolCX + 24" :y="svgToolCY - 2" text-anchor="start" fill="#c00" font-size="11" font-weight="bold">起点(刀具位置)</text>
            <text :x="svgToolCX + 24" :y="svgToolCY + 14" text-anchor="start" fill="#e0550a" font-size="11" font-weight="bold">刀具 ⌀D</text>

            <!-- G91 标注 -->
            <text x="255" y="242" text-anchor="middle" fill="#888" font-size="10">全程 G91 相对坐标</text>

            <!-- 回旋走刀 (spiral) -->
            <template v-if="pattern === 'spiral'">
                <!-- ① 左：底边外侧，标注在箭头下方 -->
                <line x1="240" y1="182" x2="100" y2="182" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="170" y="196" text-anchor="middle" fill="#e0550a" font-size="10">① 左</text>

                <!-- ② 后：左边外侧，全高 -->
                <line x1="75" y1="170" x2="75" y2="80" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="67" y="128" text-anchor="middle" fill="#e0550a" font-size="10" transform="rotate(-90,67,128)">② 后</text>

                <!-- ③ 右：顶边外侧，标注在虚线上方 -->
                <line x1="100" y1="72" x2="225" y2="72" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="163" y="66" text-anchor="middle" fill="#e0550a" font-size="10">③ 右</text>

                <!-- ④ 前：右边，首次收缩后短于② -->
                <line x1="253" y1="80" x2="253" y2="152" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="261" y="118" text-anchor="middle" fill="#e0550a" font-size="10" transform="rotate(90,261,118)">④ 前</text>

                <!-- 螺旋路径 -->
                <polyline points="255,170 87,170 87,80 237,80 237,152 105,152 105,98"
                    fill="none" stroke="#e0550a" stroke-width="1.5" stroke-dasharray="6,3" opacity="0.7"/>
            </template>

            <!-- 往复走刀 (zigzag) - 横向 - 右侧开始 -->
            <template v-else-if="zigzagDir === 'horizontal' && startSide === 'right'">
                <line x1="72" y1="208" x2="72" y2="212" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <line x1="270" y1="208" x2="270" y2="212" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <text x="72" y="222" text-anchor="middle" fill="#e0550a" font-size="9">R</text>
                <text x="270" y="222" text-anchor="middle" fill="#e0550a" font-size="9">R</text>
                <line x1="270" y1="182" x2="72" y2="182" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="196" text-anchor="middle" fill="#e0550a" font-size="10">① 左</text>
                <line x1="72" y1="152" x2="270" y2="152" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="164" text-anchor="middle" fill="#e0550a" font-size="10">② 右</text>
                <line x1="270" y1="122" x2="72" y2="122" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="134" text-anchor="middle" fill="#e0550a" font-size="10">③ 左</text>
                <line x1="72" y1="72" x2="270" y2="72" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="66" text-anchor="middle" fill="#e0550a" font-size="10">④ 右</text>
                <polyline points="270,170 72,170 72,140 270,140 270,110 72,110 72,80 270,80"
                    fill="none" stroke="#e0550a" stroke-width="1.5" stroke-dasharray="6,3" opacity="0.7"/>
            </template>

            <!-- 往复走刀 (zigzag) - 横向 - 左侧开始 -->
            <template v-else-if="zigzagDir === 'horizontal'">
                <line x1="72" y1="208" x2="72" y2="212" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <line x1="270" y1="208" x2="270" y2="212" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <text x="72" y="222" text-anchor="middle" fill="#e0550a" font-size="9">R</text>
                <text x="270" y="222" text-anchor="middle" fill="#e0550a" font-size="9">R</text>
                <line x1="72" y1="182" x2="270" y2="182" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="196" text-anchor="middle" fill="#e0550a" font-size="10">① 右</text>
                <line x1="270" y1="152" x2="72" y2="152" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="164" text-anchor="middle" fill="#e0550a" font-size="10">② 左</text>
                <line x1="72" y1="122" x2="270" y2="122" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="134" text-anchor="middle" fill="#e0550a" font-size="10">③ 右</text>
                <line x1="270" y1="72" x2="72" y2="72" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="171" y="66" text-anchor="middle" fill="#e0550a" font-size="10">④ 左</text>
                <polyline points="72,170 270,170 270,140 72,140 72,110 270,110 270,80 72,80"
                    fill="none" stroke="#e0550a" stroke-width="1.5" stroke-dasharray="6,3" opacity="0.7"/>
            </template>

            <!-- 往复走刀 (zigzag) - 纵向 - 右侧开始 -->
            <template v-else-if="startSide === 'right'">
                <line x1="52" y1="65" x2="56" y2="65" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <line x1="52" y1="185" x2="56" y2="185" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <text x="48" y="68" text-anchor="end" fill="#e0550a" font-size="9">R</text>
                <text x="48" y="188" text-anchor="end" fill="#e0550a" font-size="9">R</text>
                <line x1="268" y1="185" x2="268" y2="65" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="276" y="128" text-anchor="start" fill="#e0550a" font-size="10">① 上</text>
                <line x1="222" y1="65" x2="222" y2="185" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="202" y="128" text-anchor="end" fill="#e0550a" font-size="10">② 下</text>
                <line x1="166" y1="185" x2="166" y2="65" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="146" y="128" text-anchor="end" fill="#e0550a" font-size="10">③ 上</text>
                <line x1="110" y1="65" x2="110" y2="185" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="90" y="128" text-anchor="end" fill="#e0550a" font-size="10">④ 下</text>
                <polyline points="255,185 255,65 199,65 199,185 143,185 143,65 87,65 87,170"
                    fill="none" stroke="#e0550a" stroke-width="1.5" stroke-dasharray="6,3" opacity="0.7"/>
            </template>

            <!-- 往复走刀 (zigzag) - 纵向 - 左侧开始 -->
            <template v-else>
                <line x1="52" y1="65" x2="56" y2="65" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <line x1="52" y1="185" x2="56" y2="185" stroke="#e0550a" stroke-width="1" stroke-dasharray="3,2"/>
                <text x="48" y="68" text-anchor="end" fill="#e0550a" font-size="9">R</text>
                <text x="48" y="188" text-anchor="end" fill="#e0550a" font-size="9">R</text>
                <line x1="80" y1="185" x2="80" y2="65" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="72" y="128" text-anchor="end" fill="#e0550a" font-size="10">① 上</text>
                <line x1="126" y1="65" x2="126" y2="185" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="146" y="128" text-anchor="start" fill="#e0550a" font-size="10">② 下</text>
                <line x1="182" y1="185" x2="182" y2="65" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="202" y="128" text-anchor="start" fill="#e0550a" font-size="10">③ 上</text>
                <line x1="238" y1="65" x2="238" y2="185" stroke="#e0550a" stroke-width="1.3" marker-end="url(#arr)"/>
                <text x="258" y="128" text-anchor="start" fill="#e0550a" font-size="10">④ 下</text>
                <polyline points="87,185 87,65 143,65 143,185 199,185 199,65 255,65 255,170"
                    fill="none" stroke="#e0550a" stroke-width="1.5" stroke-dasharray="6,3" opacity="0.7"/>
            </template>
        </svg>

    </div>
</template>


<script>

import { ref, inject } from "vue";
import NumberInput from "./NumberInput.vue";


export default {
    components: { NumberInput },
    setup() {
        const fileManager = inject("fileManager");

        return {
            xTravel: ref(100),
            yTravel: ref(60),
            totalDepth: ref(0.3),
            retractHeight: ref(1),
            safeZ: ref(10),
            spindleRPM: ref(6000),
            levelDepth: ref(0.2),
            feed: ref(2000),
            toolDiameter: ref(20),
            millCutting: ref(60),
            pattern: ref("zigzag"),
            zigzagDir: ref("vertical"),
            startSide: ref("left"),
            bZReturn: ref(true),
            bZeroPass: ref(false),

            fileManager,
        };
    },

    computed: {
        millCuttingActual() {
            return this.toolDiameter * this.millCutting / 100;
        },
        // SVG 中刀具中心坐标（往复时主要方向外移刀具半径R=15px；开始位置决定起点在左/右）
        svgToolCX() {
            if (this.pattern === "zigzag" && this.zigzagDir === "horizontal") {
                return this.startSide === "right" ? 270 : 72;
            }
            if (this.pattern === "zigzag" && this.zigzagDir === "vertical") {
                return this.startSide === "right" ? 255 : 87;
            }
            return 255;
        },
        svgToolCY() {
            if (this.pattern === "zigzag" && this.zigzagDir === "vertical") return 185;
            return 170;
        },
    },

    methods: {
        // 往复（弓字形）刀路：G91 相对坐标，起点=当前刀具位置
        // 参数: w=行程长, h=行程宽, plungeZ=相对下刀深度, retZ=相对抬刀量
        // 主要方向实际行程 = 输入值 + toolDiameter（两端各多走一个刀具半径，确保完全覆盖）
        // 开始位置: 左侧=刀具在左下/左上角，右侧=刀具在右下/右上角
        generateMillFaceZigzag(w, h, plungeZ, retZ) {
            let nc = `G1 Z${plungeZ.toFixed(3)} F${this.feed}\n`;
            const toolD = this.toolDiameter;
            const startRight = this.startSide === "right";

            if (this.zigzagDir === "vertical") {
                // 纵向：沿Y轴往复，X方向步进
                const hActual = h + toolD;
                const passCount = Math.max(1, Math.ceil(w / this.millCuttingActual));
                const stepX = w / passCount;
                const stepSign = startRight ? -1 : 1; // 右侧开始→向左步进，左侧开始→向右步进

                let dir = 1;  // +1=上, -1=下
                let cx = 0, cy = 0;

                for (let i = 0; i < passCount; i++) {
                    cy += dir * hActual;
                    nc += `Y${(dir * hActual).toFixed(3)}\n`;
                    cx += stepSign * stepX;
                    nc += `X${(stepSign * stepX).toFixed(3)}\n`;
                    dir = -dir;
                    i++;
                    if (i >= passCount) break;
                    cy += dir * hActual;
                    nc += `Y${(dir * hActual).toFixed(3)}\n`;
                    cx += stepSign * stepX;
                    nc += `X${(stepSign * stepX).toFixed(3)}\n`;
                    dir = -dir;
                }
                // 末端清理走刀：dir 已指向正确反方向
                cy += dir * hActual;
                nc += `Y${(dir * hActual).toFixed(3)}\n`;
                // 抬刀并返回起点
                nc += `G0 Z${retZ.toFixed(3)}\n`;
                if (Math.abs(cx) > 0.0005 || Math.abs(cy) > 0.0005) {
                    nc += `X${(-cx).toFixed(3)}`;
                    if (Math.abs(cy) > 0.0005) nc += ` Y${(-cy).toFixed(3)}`;
                    nc += '\n';
                }
            } else {
                // 横向：沿X轴往复，Y方向步进
                const wActual = w + toolD;
                const passCount = Math.max(1, Math.ceil(h / this.millCuttingActual));
                const stepY = h / passCount;

                let dir = startRight ? -1 : 1; // 右侧开始→先向左(-1)，左侧开始→先向右(+1)
                let cx = 0, cy = 0;

                for (let i = 0; i < passCount; i++) {
                    cx += dir * wActual;
                    nc += `X${(dir * wActual).toFixed(3)}\n`;
                    cy += stepY;
                    nc += `Y${stepY.toFixed(3)}\n`;
                    dir = -dir;
                    i++;
                    if (i >= passCount) break;
                    cx += dir * wActual;
                    nc += `X${(dir * wActual).toFixed(3)}\n`;
                    cy += stepY;
                    nc += `Y${stepY.toFixed(3)}\n`;
                    dir = -dir;
                }
                // 末端清理走刀：dir 已指向正确反方向
                cx += dir * wActual;
                nc += `X${(dir * wActual).toFixed(3)}\n`;
                // 抬刀并返回起点
                nc += `G0 Z${retZ.toFixed(3)}\n`;
                if (Math.abs(cx) > 0.0005 || Math.abs(cy) > 0.0005) {
                    nc += `X${(-cx).toFixed(3)}`;
                    if (Math.abs(cy) > 0.0005) nc += ` Y${(-cy).toFixed(3)}`;
                    nc += '\n';
                }
            }

            return nc;
        },

        // 回旋刀路：起点→(-x-v,0)→(-x-v,y)→(-v,y)→(-v,v)→(-x,v)→(-x,y-v)...
        // G91 相对坐标，所有移动量相对于当前刀具位置
        // 内部维护一个"相对于起点的绝对位置"来准确计算每一步的增量
        generateMillFaceSpiral(w, h, plungeZ, retZ) {
            let v = this.millCuttingActual;

            // 边界（相对于起点的坐标）
            let curLeft = -(w + v);
            let curRight = 0;
            let curBottom = 0;
            let curTop = h;

            // 当前刀具位置（相对于起点）
            let cx = 0, cy = 0;

            // 输出相对移动指令
            const move = (x, y) => {
                let dx = x - cx, dy = y - cy;
                cx = x; cy = y;
                let s = '';
                if (Math.abs(dx) > 0.0005) s += `X${dx.toFixed(3)}`;
                if (Math.abs(dy) > 0.0005) s += (s ? ' ' : '') + `Y${dy.toFixed(3)}`;
                if (s) s += '\n';
                return s;
            };

            let nc = `G1 Z${plungeZ.toFixed(3)} F${this.feed}\n`;

            // 首段：左 + 后（全行程，不收缩）
            nc += move(curLeft, cy);     // X-(w+v)
            nc += move(cx, curTop);      // Y+h
            curRight -= v;                // 右边界收缩

            while (curLeft < curRight && curBottom < curTop) {
                // 右（沿顶边）
                nc += move(curRight, cy);
                curBottom += v;           // 底边界收缩
                if (curLeft >= curRight || curBottom >= curTop) break;

                // 前（沿右边向下）
                nc += move(cx, curBottom);
                curLeft += v;             // 左边界收缩
                if (curLeft >= curRight || curBottom >= curTop) break;

                // 左（沿底边）
                nc += move(curLeft, cy);
                curTop -= v;              // 顶边界收缩
                if (curLeft >= curRight || curBottom >= curTop) break;

                // 后（沿左边向上）
                nc += move(cx, curTop);
                curRight -= v;            // 右边界收缩
            }

            // 抬刀并返回起点（XY同时移动）
            nc += `G0 Z${retZ.toFixed(3)}\n`;
            let retXY = move(0, 0);
            if (retXY) nc += `G0 ${retXY}`;

            return nc;
        },

        generateNC() {
            // 生成时间
            const now = new Date();
            const ts = now.getFullYear() + "-"
                + String(now.getMonth() + 1).padStart(2, "0") + "-"
                + String(now.getDate()).padStart(2, "0") + " "
                + String(now.getHours()).padStart(2, "0") + ":"
                + String(now.getMinutes()).padStart(2, "0") + ":"
                + String(now.getSeconds()).padStart(2, "0");

            const patternLabel = this.pattern === "zigzag"
                ? (this.zigzagDir === "vertical" ? "往复(纵向)" : "往复(横向)")
                : "回旋";
            const sideLabel = this.startSide === "right" ? "右" : "左";
            const cornerLabel = `工件${sideLabel}下角`;
            let nc = `(顶面铣  生成时间: ${ts})\n`;
            nc += `(行程=${this.xTravel}×${this.yTravel}mm  总深度=${this.totalDepth.toFixed(2)}mm  每层下刀=${this.levelDepth.toFixed(2)}mm)\n`;
            if (this.pattern === "zigzag") {
                const actualX = this.zigzagDir === "vertical" ? this.xTravel : this.xTravel + this.toolDiameter;
                const actualY = this.zigzagDir === "vertical" ? this.yTravel + this.toolDiameter : this.yTravel;
                nc += `(实际刀路范围=${actualX.toFixed(1)}×${actualY.toFixed(1)}mm  主要方向含两端超程各R${(this.toolDiameter / 2).toFixed(1)})\n`;
            }
            nc += `(刀具直径=${this.toolDiameter}mm  面铣吃刀量=${this.millCuttingActual.toFixed(1)}mm  走刀方式=${patternLabel})\n`;
            nc += `(安全高度=${this.safeZ.toFixed(2)}mm  抬刀量=${this.retractHeight.toFixed(2)}mm  主轴=${this.spindleRPM}RPM  进给=${this.feed}mm/min)\n`;
            nc += `(使用G91增量模式  起点为当前刀具位置[${cornerLabel}]  结束后${this.bZReturn ? "返回Z原点" : "不返回Z原点"})\n`;
            if (this.bZeroPass) nc += `(Z起始位置预走一刀  Z=0不切深)\n`;
            nc += `%\n`;
            nc += `G91\n`;
            nc += `S${this.spindleRPM} M03\n`;

            const genFace = this.pattern === "zigzag"
                ? this.generateMillFaceZigzag
                : this.generateMillFaceSpiral;

            // 深度为0：仅走一刀 Z=0 表面，直接结束
            if (this.totalDepth <= 0.001) {
                nc += genFace(this.xTravel, this.yTravel, 0, this.safeZ);
                if (this.bZReturn) {
                    nc += `G1 Z${(-this.safeZ).toFixed(3)} F${this.feed}\n`;
                }
                nc += `M05\nG90\n`;
                const filename = `${this.xTravel}x${this.yTravel}x0.nc`;
                this.fileManager.addFileTab(filename, nc);
                return;
            }

            // 完整层数先行，余数放在最后一层
            let fullSteps = Math.floor(this.totalDepth / this.levelDepth);
            let remainder = this.totalDepth - fullSteps * this.levelDepth;

            // Z起始位置预走一刀（Z=0，不切深）
            if (this.bZeroPass) {
                nc += genFace(this.xTravel, this.yTravel, 0, this.retractHeight);
                // zeropass 后已抬刀至 retractHeight，后续每层需额外补偿
            }

            // 第1层直接从起点下刀；后续每层需先补偿上次抬刀量再加深
            // 若有 zeropass，第1层也需补偿抬刀量
            for (let i = 0; i < fullSteps; i++) {
                let plungeZ = (i === 0 && !this.bZeroPass)
                    ? -this.levelDepth
                    : -(this.retractHeight + this.levelDepth);
                nc += genFace(this.xTravel, this.yTravel, plungeZ, this.retractHeight);
            }

            // 余数层（最后一层使用安全高度抬刀，genFace内已返回XY起点）
            if (remainder > 0.001 || fullSteps === 0) {
                const needCompensate = this.bZeroPass || fullSteps > 0;
                let plungeZ = !needCompensate
                    ? -this.totalDepth
                    : -(this.retractHeight + remainder);
                nc += genFace(this.xTravel, this.yTravel, plungeZ, this.safeZ);
            } else {
                // 最后抬到安全高度（XY已在genFace最后一层返回）
                nc += `G0 Z${this.safeZ.toFixed(3)}\n`;
            }

            // 从安全高度降回起点Z高度
            if (this.bZReturn) {
                let finalZ;
                if (remainder > 0.001 || fullSteps === 0) {
                    finalZ = this.safeZ - this.totalDepth;
                } else {
                    finalZ = this.retractHeight + this.safeZ - this.totalDepth;
                }
                nc += `G1 Z${(-finalZ).toFixed(3)} F${this.feed}\n`;
            }

            // 关主轴，恢复绝对坐标模式
            nc += `M05
G90
`;

            const filename = `${this.xTravel}x${this.yTravel}x${this.totalDepth}.nc`;
            this.fileManager.addFileTab(filename, nc);
        },
    },
};

</script>
